import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import transformHref from 'core/utils/transformHref';
import NavCategoryMarkup from './NavCategoryMarkup';

class NavCategory extends PureComponent {
	render() {
		const {
			slug,
			href,
			type,
			windowSlug,
			linkColor,
			accentColor,
			children,
		} = this.props;

		let items = [];
		children.forEach(c => items = items.concat(c.items));
		let subcatSlugs = items.reduce((acc, cur) => {
			if(typeof cur != "undefined") {
				acc.push(cur.slug);
			}
			return acc;
		}, []);

		const slugIsSubnavSlug = this.props.subnavSlug === slug;
		const slugIsWindowSlug = windowSlug === slug || subcatSlugs.includes(windowSlug);

		const markupProps = {
			icon: this.props.icon,
			long: this.props.long,
			short: this.props.short,
			onMouseEnter: this.props.onMouseEnter,
			onMouseLeave: this.props.onMouseLeave,
			href: href ? href : transformHref({ slug, type }),
			highlight: slugIsWindowSlug || slugIsSubnavSlug,
			slug,
			type,
			linkColor,
			accentColor,
		};

		return (
			<NavCategoryMarkup {...markupProps} />
		);
	}

	static propTypes = {
		windowSlug: PropTypes.string,
		slug: PropTypes.string.isRequired,
		href: PropTypes.string,
		long: PropTypes.string.isRequired,
		short: PropTypes.string.isRequired,
		subnavSlug: PropTypes.string,
		type: PropTypes.oneOf(["campaign", "category", "collection"]),
		icon: PropTypes.bool,
		onMouseEnter: PropTypes.func,
		onMouseLeave: PropTypes.func,
		linkColor: PropTypes.string,
		accentColor: PropTypes.string,
		children: PropTypes.array,
	};

	static defaultProps = {
		type: "category",
		icon: false,
	}
}

export default NavCategory;
